import { ServerClient } from 'common/utils/http/http-clients';
import { IColumnsSetting } from './export.service.models';
import { trackPromise } from 'react-promise-tracker';
import dayjs from 'dayjs';

class ExportService {
  processTrafficLogs(
    pageLimit: any,
    filter: string | null | undefined,
    sort: string | null | undefined,
    search: string | null | undefined,
    columnsSetting: IColumnsSetting,
    isArchive: boolean = false,
  ): Promise<any> {
    const path = isArchive ? '/export/csv/traffic-logs/archive' : '/export/csv/traffic-logs';
    columnsSetting.utcOffset = dayjs().utcOffset() / 60;

    return trackPromise(
      ServerClient.post<any>(path, columnsSetting, {
        responseType: 'blob',
        params: {
          filter,
          ...pageLimit,
          sort,
          search,
        },
      }).then((res) => res?.data),
    );
  }

  sendTrafficCsvReport(
    pageLimit: any,
    filter: string | null | undefined,
    sort: string | null | undefined,
    search: string | null | undefined,
    body: any,
    isArchive: boolean = false,
  ): Promise<any> {
    const path = isArchive ? '/export/csv/traffic-logs/archive/reports/email' : '/export/csv/traffic-logs/reports/email';

    const columnSettings: IColumnsSetting = {
      columns: body.columns,
      utcOffset: dayjs().utcOffset() / 60,
    };

    const request = {
      columnSettings,
      email: body.email,
    };

    body.columns.utcOffset = dayjs().utcOffset() / 60;

    return trackPromise(
      ServerClient.post<any>(path, request, {
        responseType: 'blob',
        params: {
          filter,
          ...pageLimit,
          sort,
          search,
        },
      }).then((res) => res?.data),
    );
  }

  async processResidents(): Promise<any> {
    const res = await ServerClient.post<any>(`/export/csv/residents`, null, { responseType: 'blob' });
    return res?.data;
  }
  async processResidentGuests(): Promise<any> {
    const res = await ServerClient.post<any>(`/export/csv/residents/guests`, null, { responseType: 'blob' });
    return res?.data;
  }
  async processResidentVehicles(): Promise<any> {
    const res = await ServerClient.post<any>(`/export/csv/residents/vehicles`, null, { responseType: 'blob' });
    return res?.data;
  }
  async processResidentAccessCards(): Promise<any> {
    const res = await ServerClient.post<any>(`/export/csv/residents/access-cards`, null, { responseType: 'blob' });
    return res?.data;
  }

  async processCitations(pageLimit: any, filter: string | null | undefined, sort: string | null | undefined): Promise<any> {
    const res = await ServerClient.post<any>(`/export/csv/citations`, null, {
      responseType: 'blob',
      params: {
        filter,
        ...pageLimit,
        sort,
      },
    });
    return res?.data;
  }

  async processActivityLogs(pageLimit: any, filter: string | null | undefined, sort: string | null | undefined): Promise<any> {
    const res = await ServerClient.post<any>(`/export/csv/activity-logs`, null, {
      responseType: 'blob',
      params: {
        filter,
        ...pageLimit,
        sort,
      },
    });
    return res?.data;
  }
}

export const exportService = new ExportService();
export default exportService;
